import React, { Component } from 'react'
import PropTypes from 'prop-types'
import lightwallet from 'eth-lightwallet'
import { getBalance } from '../../user/actions/GetInfo'
import { connect } from 'react-redux'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {
  Container,
  Header,
  Segment,
  Icon,
  Button
} from 'semantic-ui-react'

class MyWallet extends Component {
    constructor(props) {
        super(props)
	
        this.state = {
            address: '',
            copySuccess: false,
            loading: false
        }
    }

    componentWillMount(){

        let { dispatch, authData } = this.props
        
        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        this.setState({ address: address[0] });
        
        dispatch(getBalance(address[0]))        
    }

    refreshBalance(){

        let { dispatch } = this.props
        
        this.setState({ loading: true });

        this.timeout = setTimeout(() => {
            this.setState({ loading: false })
        }, 1500)

        dispatch(getBalance(this.state.address))     
    }
  
    copyToClipboard() {

        this.setState({ copySuccess: true });

        this.timeout = setTimeout(() => {
            this.setState({ copySuccess: false })
        }, 1500)
    }
  
    render() {
        return(
            <div> 
                <Segment textAlign='center' style={{  paddingTop: '1em 0em' }} vertical>
                    <Container>
                        <Header as='h1' content='Your Wallet' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                        <Container textAlign='left' text>
                            <p>Address & Balance:</p>
                        </Container>
                    </Container>
                </Segment>
                <Segment inverted style={{ padding: '1em 0em' }} vertical>
                    <Container text>
                        <Header inverted as='h2'>
                            <Icon name='address book outline' />
                            <Header.Content>
                                <CopyToClipboard text={this.state.address} onCopy={this.copyToClipboard.bind(this)}>
                                    <span style={{cursor: 'pointer'}}>{this.state.address}</span>
                                </CopyToClipboard>
                                {this.state.copySuccess ? <span> ✓</span> : ''}				
                                <Header.Subheader>
                                    {this.props.balance}{' '}<Icon loading={this.state.loading} onClick={() => this.refreshBalance()} link name='refresh'  />
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Container>
                </Segment>
                <Segment textAlign='center' style={{  minHeight: 400, padding: '1em 0em' }} vertical>
                    <Container textAlign='left' text>
                        <p>To make any transactions in <a href='https://ethereum.org/' target="_blank">Ethereum</a> blockchain you should have some Ether in your wallet. Since we use <a href='https://rinkeby.etherscan.io/' target="_blank">Rinkeby Testnet</a> you can get it for free by <a href='https://faucet.rinkeby.io/' target="_blank">Rinkeby Authenticated Faucet</a>. Click button below and see how does this work.</p>
                        <Button.Group size='large'>	
                            <Button positive as='a' href='https://faucet.rinkeby.io/' target='_blank'>Get Ether</Button>
                        </Button.Group> 
                    </Container>		  
                </Segment>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        balance: state.user.data.addressBalance
    }
}

export default connect(mapStateToProps)(MyWallet)

MyWallet.propTypes = {
    balance: PropTypes.string,
    authData: PropTypes.object,
    dispatch: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/layouts/mywallet/MyWallet.js